const overviewPurchaseOrdersApprovalTableHeaders = [
  {
    id: 'data',
    group: 'Data',
    canPrint: true
  },
  {
    id: 'aguardandoAprovacao',
    group: 'Aguardando Aprovação',
    canPrint: true,
    align: 'right'
  },
  {
    id: 'recusado',
    group: 'Rejeitado',
    canPrint: true,
    align: 'right'
  }
]

export default overviewPurchaseOrdersApprovalTableHeaders
